module.exports = __webpack_public_path__ + "static/media/logo-01.1b750e8d.gif";